import { render, staticRenderFns } from "./FormEventPlaces.vue?vue&type=template&id=69224645&"
import script from "./FormEventPlaces.vue?vue&type=script&lang=js&"
export * from "./FormEventPlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69224645')) {
      api.createRecord('69224645', component.options)
    } else {
      api.reload('69224645', component.options)
    }
    module.hot.accept("./FormEventPlaces.vue?vue&type=template&id=69224645&", function () {
      api.rerender('69224645', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event/places/form/FormEventPlaces.vue"
export default component.exports